<template>
  <div>
    <form
      data-vv-scope="newsLetterForm"
      novalidate=""
    >
      <input
        type="email"
        class="form-control"
        :placeholder="$t(data.placeholderText)"
        id="newsletter-email"
        name="email"
        v-model="emailId"
        v-validate="'required|email'"
        :class="(showFormError &&
                       errors.has('newsLetterForm.email'))?'is-invalid':''"
								data-test="newsLetterEmailInput"
      >
      <div
        class="invalid-feedback"
        v-if="showFormError"
        v-show="errors.has('newsLetterForm.email')"
        id="newsLetter-email-error"
								data-test="newsLetterEmailInputError"
      >
        {{errors.first('newsLetterForm.email')}}
      </div>
      <button
        type="submit"
        id="newsletter-btn"
								class="wp_subscribeBtn"
        @click.prevent="action('newsLetterForm')"
								data-test="newsLetterBtn"
      >
        {{$t(data.buttonText)}}
      </button>
    </form>
  </div>
</template>

<script>
import { customerApi } from '@/services/ApiServices/customerApi'

export default {
	props: {
		data: {
			type: Object
		}
	},
	name: 'news-letter-form',
	data () {
		return {
			emailId: '',
			showFormError: false
		}
	},
	methods: {
		action (scope) {
			this.$validator.validateAll(scope)
				.then((result) => {
					if (result) {
						this.showFormError = false
						this.subscribeNewsLetter()
					} else {
						this.showFormError = true
					}
				})
		},
		subscribeNewsLetter () {
			const emailid = {
				email: this.emailId
			}
			customerApi.subscribe(emailid).then((res) => {
				this.$toasted.show('YOU ARE SUCCESSFULLY SUBSCRIBED TO THE NEWSLETTER')
			}).catch((e) => {

			})
			this.resetEmail()
		},
		resetEmail () {
			this.emailId = ''
		}
	}
}
</script>

<style scoped>
</style>
